import React, { useState, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'app/AppStore'
import { useWalletCurrencyQuery } from 'entities/psp/api/walletApi'
import { walletApi } from 'entities/psp/api/walletApi'
import {
  BitcoinIcon,
  Icon,
  ToncoinIcon,
  BitcoinCashIcon,
  EosIcon,
  StellarIcon,
  ShibaIcon,
  NotcoinIcon,
  EthereumClasicIcon,
  ZcashIcon,
  CordanoIcon,
  DashIcon,
  MoneroIcon,
  DogecoinIcon,
  LitecoinIcon,
  TetherBepIcon,
  BinanceCoinIcon,
  TetherTonIcon,
  EthereumIcon,
  SolanaIcon,
  UsdTrcIcon,
  TetherSolIcon,
  TetherErcIcon,
  TetherTrcIcon,
  UsdCoinIcon,
  RippleIcon,
  TronIcon,
} from 'shared/ui/Icon/Icon'
import QRCode from 'qrcode.react'
import { TextInput } from 'shared/ui/TextInput/TextInput'
import styled from 'styled-components'
import styles from '../Deposit.module.sass'
import cn from 'classnames'
import { priceToView } from 'shared/utils/format/currency'

const STEPS = {
  INPUT: 1,
  WALLET: 2,
}

const renderIcon = iconName => {
  if (iconName === 'Bitcoin') {
    return <BitcoinIcon />
  }
  if (iconName === 'Ethereum') {
    return <EthereumIcon />
  }
  if (iconName === 'Tether ERC-20') {
    return <TetherErcIcon />
  }

  if (iconName === 'USD Coin ERC-20') {
    return <UsdCoinIcon />
  }
  if (iconName === 'Ripple') {
    return <RippleIcon />
  }
  if (iconName === 'TRON') {
    return <TronIcon />
  }
  if (iconName === 'Tether TRC-20') {
    return <TetherTrcIcon />
  }

  if (iconName === 'USD Coin TRC-20') {
    return <UsdTrcIcon />
  }
  if (iconName === 'Solana') {
    return <SolanaIcon />
  }
  if (iconName === 'Tether SOL') {
    return <TetherSolIcon />
  }
  if (iconName === 'Toncoin') {
    return <ToncoinIcon />
  }
  if (iconName === 'Tether TON') {
    return <TetherTonIcon />
  }
  if (iconName === 'Binance Coin') {
    return <BinanceCoinIcon />
  }

  if (iconName === 'Tether BEP-20') {
    return <TetherBepIcon />
  }
  if (iconName === 'Dogecoin') {
    return <DogecoinIcon />
  }
  if (iconName === 'Litecoin') {
    return <LitecoinIcon />
  }
  if (iconName === 'Monero') {
    return <MoneroIcon />
  }

  if (iconName === 'Cardano') {
    return <CordanoIcon />
  }
  if (iconName === 'Dash') {
    return <DashIcon />
  }

  if (iconName === 'Bitcoin Cash') {
    return <BitcoinCashIcon />
  }
  if (iconName === 'Zcash') {
    return <ZcashIcon />
  }

  if (iconName === 'Ethereum Classic') {
    return <EthereumClasicIcon />
  }
  if (iconName === 'Notcoin') {
    return <NotcoinIcon />
  }
  if (iconName === 'SHIBA INU BEP-20') {
    return <ShibaIcon />
  }

  if (iconName === 'EOS') {
    return <EosIcon />
  }
  if (iconName === 'Stellar') {
    return <StellarIcon />
  }
}

export const WestWalletFlow = ({ activeTitle, copyToClipboard, me }) => {
  const dispatch = useAppDispatch()
  const [clicekd, setClicked] = useState(false)
  const [clikckedItem, setClickedItem] = useState(null)
  const [steps, setSteps] = useState(STEPS.INPUT)
  const [address, setAddress] = useState('')
  const [value, setValue] = useState(0)

  const { data } = useWalletCurrencyQuery({
    leadId: me.id,
    userId: me.assigned_to,
  })

  const handleClickOtherItem = item => {
    setClicked(true)
    setClickedItem(item)
  }

  const handleGetAddress = async () => {
    const res = await dispatch(
      walletApi.endpoints.walletAddress.initiate({
        leadId: me.id,
        type: clikckedItem?.tickers?.[0],
        userId: me.assigned_to,
        wallet_id: me.wallet.id,
      }),
    ).unwrap()

    setAddress(res.data.address)
  }

  useEffect(() => {
    if (steps === STEPS.WALLET) {
      handleGetAddress()
    }
  }, [steps])

  return (
    <div>
      {clicekd ? (
        <>
          {steps === STEPS.INPUT && (
            <div>
              <TextInput
                onChange={e => setValue(e.target.value)}
                value={value}
                label='Enter Deposit Amount'
                type={'number'}
              />
              <button
                className='button-stroke button-small'
                onClick={() => setSteps(STEPS.WALLET)}
                style={{ display: 'block', margin: '20px auto' }}
              >
                Next
              </button>
            </div>
          )}
          {steps === STEPS.WALLET && (
            <>
              {' '}
              <div
                className={styles.preview}
                onClick={() => copyToClipboard(clikckedItem?.wallet)}
              >
                <QRCode value={address || clikckedItem?.wallet} size={128} />
              </div>
              <div className={styles.code}>
                <div className={styles.number}>
                  {address || clikckedItem?.wallet || '-'}
                </div>
                <button
                  onClick={() => copyToClipboard(clikckedItem?.wallet)}
                  className={styles.copy}
                >
                  <Icon name='copy' size='24' />
                </button>
              </div>
              <div className={styles.row}>
                <p>Payment Method:</p>
                <p>{clikckedItem?.tickers?.[0]}</p>
              </div>
              <div className={styles.row}>
                {' '}
                <p>Send:</p>
                <p>{priceToView(value)}</p>
              </div>
              <div className={styles.row}>
                {' '}
                <p>Will be credited:</p>
                <p>
                  <p>
                    {priceToView(
                      (
                        +value -
                        (+value * Number(clikckedItem.fee)) / 100
                      ).toFixed(2),
                    )}
                  </p>{' '}
                </p>{' '}
              </div>
            </>
          )}
        </>
      ) : (
        <OtherWrapper>
          {data?.data?.map((item, idx) => (
            <li
              className={cn(styles.liWrapper, styles.cryptoItem)}
              key={idx}
              onClick={() => handleClickOtherItem(item)}
            >
              <div
                style={{ zoom: '0.5' }}
                className={cn(`symbol symbol-${item.crypto_item}`)}
              ></div>
              <p>{item.name}</p>
              {renderIcon(item.name)}
              {/* <img src={item.logo} alt={item.title} /> */}
            </li>
          ))}
        </OtherWrapper>
      )}
    </div>
  )
}

const OtherWrapper = styled.ul`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 20px;
`
